import { render } from "./discountModel.vue?vue&type=template&id=af388666"
import script from "./discountModel.vue?vue&type=script&lang=js"
export * from "./discountModel.vue?vue&type=script&lang=js"

import "./discountModel.vue?vue&type=style&index=0&id=af388666&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__